import {createI18n} from 'vue-i18n'
import {createVuetify} from "vuetify";
import {aliases, md} from 'vuetify/iconsets/md'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import migrateUserPrefs from "../../migration"
import PrefsService from "../../services/PrefsService"

import enMessages from '../../i18n/resource/en'
import {DateTime as DateTimeEn} from '../../i18n/resource/en/common'
import esMessages from '../../i18n/resource/es'
import {DateTime as DateTimeEs} from '../../i18n/resource/es/common'

import 'material-icons/iconfont/material-icons.css'
import "vuetify/dist/vuetify.min.css"
import "../../style/ncsOverrides.scss"
import NCSThemes from "../../style/NCSThemes"

function configureI18n()
{
    console.log ("***********************Configuring i18n for NCS Vue App")
    // Configure internationalization
    const i18n = createI18n({
        //legacy: false, // Use Composition API
        //allowComposition: true,
        locale: 'en',
        fallbackLocale: 'en',
        messages: {en: enMessages, es: esMessages},
        silentTranslationWarn: true,
        dateTimeFormats: {en: DateTimeEn, es: DateTimeEs},
    })
    i18n.nmt = lookupTranslation
    return (i18n)
}

/**
 * Starting in vue-i18n v9, the t() function returns only a string and you have to use the tm() function to get an array
 * This function will emcapsulate that logic so we don't have to put this all this code everywhere
 * @param key the key to look up
 * @returns {any} string or array of strings
 */
function lookupTranslation(key)
{
    let result = i18n.global.t(key)
    if (result === key)
    {
        result = i18n.global.tm(key)
        if (Object.keys(result).length === 0)
        {
            console.warn ("No i18n data found for key", key)
        }
    }
    return result
}

export function setupVuetify()
{
    // Get from prefs
    const validThemeNames = Object.values(NCSThemes).map(theme => theme.name)
    let currThemeName = PrefsService.get ('colorTheme')
    if (!validThemeNames.includes(currThemeName))
    {
        console.warn(`Invalid or missing theme name "${currThemeName}", falling back to ${NCSThemes.NCSLight.name}`)
        currThemeName = NCSThemes.NCSLight.name
    }
    const vuetify = createVuetify({
        icons: {
            defaultSet: 'md',
            aliases,
            sets: {md}
        },
        theme: {
            options:{
                customProperties: true, // Enable CSS variables for theme colors
            },
            defaultTheme: currThemeName,
            themes:
                {
                    NCSLight: NCSThemes.NCSLight,
                    NCSLightAccessible1: NCSThemes.NCSLightAccessible1,
                    //NCSDark: NCSThemes.NCSDark,
                }
        },
        components, directives,
    })
    return vuetify
}

export async function setupPrefs ()
{
    // Configure user preferences
    let userPrefsOptions = {
        useSessionOnly: false,
        axiosConfig: {url: '/api/userprefs/v1'}
    }

    // have Vue.use call the Prefs constructor with the userPrefsOptions plus TRUE so that we have
    // to call the loadPrefsFromServer function to init preferences here
    try
    {
        await PrefsService.loadPrefsFromServer(userPrefsOptions)
        migrateUserPrefs()
    }
    catch (e)
    {
        console.error ('Error loading user preferences:', e)
    }
}
export const i18n = configureI18n();